import { Grid2, Tooltip, Typography } from '@mui/material';
import { INewStudyForm } from './_types';
import FormInput from 'components/Form/Input/Input';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';
import { useAppInfo } from 'utils/hooks/useAppInfo';
import FormDatePicker from 'components/Form/Date/Date';
import FormSelect from 'components/Form/Select/Select';
import useValidationSchema from './_form';

export const NewStudyForm: React.FC<INewStudyForm> = ({
  dicomData,
  initialValues,
  isRequest,
  isRequestEdit,
  sourceStudy,
  targetStudy,
}) => {
  const { t } = useTranslation('Studies');
  const { portalSetting } = useAppInfo();
  const { fields } = useValidationSchema(t, portalSetting);

  return (
    <>
      {fields.map((section) => (
        <Grid2 container={true} key={section.id} spacing={1}>
          {section.label ? (
            <Grid2 size={12}>
              <Typography sx={{ mt: 1, fontWeight: 'bold' }}>{section.label}</Typography>
            </Grid2>
          ) : null}
          {section.fields.map((field) => {
            const type = get(field, 'type', 'text');
            return (
              <Grid2
                size={{ xs: 12, md: 6, lg: 4 }}
                key={field.name}
                sx={{
                  maxWidth: {
                    xl: `30%`,
                  },
                }}
              >
                {type === 'div' && (
                  <Typography variant="body1" sx={{ mt: 2, fontWeight: 'bold' }}>
                    {field.label}
                  </Typography>
                )}
                {type === 'select' && <FormSelect {...field} />}

                {type === 'date' && <FormDatePicker {...field} />}
                {type === 'number' &&
                  (get(field, 'tooltip', false) ? (
                    <Tooltip title={field.tooltip}>
                      <span style={{ paddingBottom: '1rem' }}>
                        <FormInput {...field} type="number" />
                      </span>
                    </Tooltip>
                  ) : (
                    <FormInput {...field} type="number" />
                  ))}
                {['text', 'time'].includes(type) && <FormInput {...field} type="text" />}
              </Grid2>
            );
          })}
        </Grid2>
      ))}
    </>
  );
};
